export default __webpack_public_path__ + "static/media/Pistol_6.2b5dc897.png";